<phx-input-group [phxPrefix]="searchIcon" [phxSuffix]="searchValue.value ? clearIcon : null">
  <input phx-input [placeholder]="phxPlaceholder || ('Search' | phxTranslate)" [autofocus]="phxAutoFocus" [disabled]="disabled" [phxInputStyle]="phxInputStyle" [formControl]="searchValue" (input)="updateModel()" (focus)="phxFocus.emit($event)" (blur)="phxBlur.emit($event)"/>
</phx-input-group>

<ng-template #searchIcon>
  <i phx-icon [phxIcon]="MagnifyingGlassIcon"></i>
</ng-template>

<ng-template #clearIcon>
  <button phx-button phxButtonType="icon" [phxSuffixIcon]="crossIcon" (phxOnClick)="onClear()"></button>
</ng-template>